function checkWizzyConfigAndUpdate() {
  if (window.wizzyConfig.common.isOnCategoryPage == true) {
    window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
      "#wizzy-shopify-collection-page-wrapper",
    ];
  } else {
    window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
  }
  // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
  //   ".shopify-section.shopify-section--bordered .Container",
  // ];
  // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
  // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main"); // Dom to be replaced
  window.wizzyConfig &&
    (window.matchMedia("(max-width: 768px)").matches
      ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "input[type='search']", // mobile searchbar
          type: "search",
        })
      : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "input[type='search']", // desktop searchbar
          type: "search",
        }),
    clearInterval(interval));
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);
window.onWizzyScriptLoaded = function () {
  function containsCollection(collectionHandle) {
    const collectionArray = [
      "https://www.truebrowns.com/collections/test-collection",
      // "https://www.truebrowns.com/collections/kurta-sets",
      // "https://www.truebrowns.com/collections/co-ords",
      "https://www.truebrowns.com/collections/saree",
      "https://www.truebrowns.com/collections/umang-now-live",
      "https://www.truebrowns.com/collections/blouse-1",
      "https://www.truebrowns.com/collections/jacket-sets",
      "https://www.truebrowns.com/collections/all-in-men",
      "https://www.truebrowns.com/collections/co-ord-sets",
      "https://www.truebrowns.com/collections/kurta",
      "https://www.truebrowns.com/collections/jacket",
      "https://www.truebrowns.com/collections/shirt",
      "https://www.truebrowns.com/collections/sale-3",
      "https://www.truebrowns.com/collections/black-friday-sale",
    ];

    let found = false;
    collectionArray.forEach((col) => {
      if (col.includes(collectionHandle)) {
        found = true;
      }
    });

    return found;
  }

  function containsCollectionForHero(collectionHandle) {
    const collectionArray = [
      "https://www.truebrowns.com/collections/wedding-collection",
      "https://www.truebrowns.com/collections/evening-wear",
      "https://www.truebrowns.com/collections/office-wear",
      "https://www.truebrowns.com/collections/casual-wear",
      "https://www.truebrowns.com/collections/festivewear-men",
      "https://www.truebrowns.com/collections/eveningwear-men",
      "https://www.truebrowns.com/collections/officewear-men",
      "https://www.truebrowns.com/collections/casualwear-men",
      "https://www.truebrowns.com/collections/plus-size-store",
      "https://www.truebrowns.com/collections/sale-2",

      "https://www.truebrowns.com/collections/wedding-womens",
      "https://www.truebrowns.com/collections/wedding-mens",
      "https://www.truebrowns.com/collections/sangeet",
      "https://www.truebrowns.com/collections/haldi",
      "https://www.truebrowns.com/collections/mehendi",
      "https://www.truebrowns.com/collections/d-day",
      "https://www.truebrowns.com/collections/soiree",
      "https://www.truebrowns.com/collections/brides-brigade",
      "https://www.truebrowns.com/collections/grooms-gang",
      "https://www.truebrowns.com/collections/the-black-friday-sale",
      "https://www.truebrowns.com/collections/all-in-winter",
      "https://www.truebrowns.com/collections/new-velvet",
      "https://www.truebrowns.com/collections/bottoms-1",
      "https://www.truebrowns.com/collections/timeless-wedding-styles",
      "https://www.truebrowns.com/collections/buy-3-eoss-offer",
      "https://www.truebrowns.com/collections/buy-2-eoss-offer",
      "https://www.truebrowns.com/collections/world-saree-day",
      "https://www.truebrowns.com/collections/summer",
      // "https://www.truebrowns.com/collections/dress",
      "https://www.truebrowns.com/collections/spring-summer-25",
      "https://www.truebrowns.com/collections/valentines-day",
    ];

    let found = false;
    collectionArray.forEach((col) => {
      if (col.includes(collectionHandle)) {
        found = true;
      }
    });

    return found;
  }

  function containsCollectionForHeroColor(collectionHandle) {
    const collectionArray = [
      "https://www.truebrowns.com/collections/durga-pujo",
      "https://www.truebrowns.com/collections/karva-chauth",
      "https://www.truebrowns.com/collections/sale-4",
      "https://www.truebrowns.com/collections/holi-special",
    ];
    let found = false;
    collectionArray.forEach((col) => {
      if (col.includes(collectionHandle)) {
        found = true;
      }
    });

    return found;
  }

  function containsCollectionForBestSellingSort(collectionHandle) {
    const collectionArray = [
      "https://www.truebrowns.com/collections/winter-24",

      "https://www.truebrowns.com/collections/wedding-festivities",
    ];
    let found = false;
    collectionArray.forEach((col) => {
      if (col.includes(collectionHandle)) {
        found = true;
      }
    });

    return found;
  }

  function containsCollectionForNewestFirst(collectionHandle) {
    const collectionArray = [
      "https://www.truebrowns.com/collections/kurta-sets",
      "https://www.truebrowns.com/collections/co-ords",
      "https://www.truebrowns.com/collections/dress",
    ];

    let found = false;
    collectionArray.forEach((col) => {
      if (col.includes(collectionHandle)) {
        found = true;
      }
    });

    return found;
  }

  const addNewestFirstSorting = (filter) => {
    let isJson = false;
    let isSortJson = false;
    if (typeof filter == "string") {
      isJson = true;
      filter = JSON.parse(filter);
    }
    if (typeof filter.sort == "string") {
      isSortJson = true;
      filter.sort = JSON.parse(filter.sort);
    }
    let newSort = [];

    //when sort is relevance than update sort as per requierment
    if (filter.sort[0].field === "createdAt") {
      newSort.push({
        field: "createdAt",
        order: "desc",
      });
      filter.sort.forEach((x) => {
        if (x.field != "createdAt") {
          newSort.push(x);
        }
      });
    } else {
      //else make sure that selected sort is applying
      newSort = filter.sort;
    }
    filter.sort = newSort;
    if (isSortJson) {
      filter.sort = JSON.stringify(filter.sort);
    }
    if (isJson) {
      filter = JSON.stringify(filter);
    }
  };

  const addBestSellerAndSizeSorting = (filter) => {
    let isJson = false;
    let isSortJson = false;
    if (typeof filter == "string") {
      isJson = true;
      filter = JSON.parse(filter);
    }
    if (typeof filter.sort == "string") {
      isSortJson = true;
      filter.sort = JSON.parse(filter.sort);
    }
    let newSort = [];

    //when sort is relevance than update sort as per requierment
    if (filter.sort[0].field === "relevance") {
      newSort.push(
        {
          field: "product_wizzy-best-selling_sortOrder:float",
          order: "asc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_ksa:float",
          order: "desc",
          // order: "asc",
        }
      );
      filter.sort.forEach((x) => {
        if (
          x.field != "product_ksa:float" &&
          x.field != "product_wizzy-best-selling_sortOrder"
        ) {
          newSort.push(x);
        }
      });
    } else {
      //else make sure that selected sort is applying
      newSort = filter.sort;
    }
    filter.sort = newSort;
    if (isSortJson) {
      filter.sort = JSON.stringify(filter.sort);
    }
    if (isJson) {
      filter = JSON.stringify(filter);
    }
  };

  const addCollectionSorting = (filter) => {
    let isJson = false;
    let isSortJson = false;
    if (typeof filter == "string") {
      isJson = true;
      filter = JSON.parse(filter);
    }
    if (typeof filter.sort == "string") {
      isSortJson = true;
      filter.sort = JSON.parse(filter.sort);
    }
    let newSort = [];
    //when sort is relevance than update sort as per requierment
    if (filter.sort[0].field === "relevance") {
      newSort.push(
        {
          field: "product_value_tags_occasion1_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion2_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion3_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion4_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_ksa:float",
          order: "desc",
          // order: "asc",
        },
        {
          field: "product_wizzy-best-selling_sortOrder:float",
          order: "asc",
          isForParent: "true",
          isForVariation: "false",
        }
      );
      filter.sort.forEach((x) => {
        if (
          x.field != "product_ksa:float" &&
          x.field != "product_value_tags_occasion1_ruled_based_bt" &&
          x.field != "product_value_tags_occasion2_ruled_based_bt" &&
          x.field != "product_value_tags_occasion3_ruled_based_bt" &&
          x.field != "product_value_tags_occasion4_ruled_based_bt"
        ) {
          newSort.push(x);
        }
      });
    } else {
      //else make sure that selected sort is applying
      newSort = filter.sort;
    }
    filter.sort = newSort;
    if (isSortJson) {
      filter.sort = JSON.stringify(filter.sort);
    }
    if (isJson) {
      filter = JSON.stringify(filter);
    }
  };

  const addCollectionColorSort = (filter) => {
    let isJson = false;
    let isSortJson = false;
    if (typeof filter == "string") {
      isJson = true;
      filter = JSON.parse(filter);
    }
    if (typeof filter.sort == "string") {
      isSortJson = true;
      filter.sort = JSON.parse(filter.sort);
    }
    let newSort = [];

    //when sort is relevance than update sort as per requierment
    if (filter.sort[0].field === "relevance") {
      newSort.push(
        //add new wizzy-hero-product-color sort
        {
          field: "product_Wizzy_Hero_Product_tags:float",
          order: "asc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion1_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion2_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion3_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion4_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_ksa:float",
          order: "desc",
          // order: "asc",
        },
        {
          field: "product_wizzy-best-selling_sortOrder:float",
          order: "asc",
          isForParent: "true",
          isForVariation: "false",
        }
      );
      filter.sort.forEach((x) => {
        if (
          x.field != "product_ksa:float" &&
          x.field != "product_value_tags_occasion1_ruled_based_bt" &&
          x.field != "product_value_tags_occasion2_ruled_based_bt" &&
          x.field != "product_value_tags_occasion3_ruled_based_bt" &&
          x.field != "product_value_tags_occasion4_ruled_based_bt"
        ) {
          newSort.push(x);
        }
      });
    } else {
      //else make sure that selected sort is applying
      newSort = filter.sort;
    }
    filter.sort = newSort;
    if (isSortJson) {
      filter.sort = JSON.stringify(filter.sort);
    }
    if (isJson) {
      filter = JSON.stringify(filter);
    }
  };

  const addCollectionSortingWithHero = (filter) => {
    let isJson = false;
    let isSortJson = false;
    if (typeof filter == "string") {
      isJson = true;
      filter = JSON.parse(filter);
    }
    if (typeof filter.sort == "string") {
      isSortJson = true;
      filter.sort = JSON.parse(filter.sort);
    }
    let newSort = [];
    //when sort is relevance than update sort as per requierment
    if (filter.sort[0].field === "relevance") {
      newSort.push(
        {
          //add new wizzy-hero-product sort
          field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion1_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion2_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion3_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_value_tags_occasion4_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        },
        {
          field: "product_ksa:float",
          order: "desc",
          // order: "asc",
        },
        {
          field: "product_wizzy-best-selling_sortOrder:float",
          order: "asc",
          isForParent: "true",
          isForVariation: "false",
        }
      );
      filter.sort.forEach((x) => {
        if (
          x.field != "product_ksa:float" &&
          x.field != "product_value_tags_occasion1_ruled_based_bt" &&
          x.field != "product_value_tags_occasion2_ruled_based_bt" &&
          x.field != "product_value_tags_occasion3_ruled_based_bt" &&
          x.field != "product_value_tags_occasion4_ruled_based_bt"
        ) {
          newSort.push(x);
        }
      });
      if (window.wizzyConfig.common.collectionHandle === "haldi") {
        newSort.unshift({
          field: "product_value_tags_haldi_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        });
      } else if (window.wizzyConfig.common.collectionHandle === "sangeet") {
        newSort.unshift({
          field: "product_value_tags_sangeet_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        });
      } else if (window.wizzyConfig.common.collectionHandle === "soiree") {
        newSort.unshift({
          field: "product_value_tags_soiree_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        });
      } else if (window.wizzyConfig.common.collectionHandle === "d-day") {
        newSort.unshift({
          field: "product_value_tags_dday_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        });
      } else if (window.wizzyConfig.common.collectionHandle === "mehendi") {
        newSort.unshift({
          field: "product_value_tags_mehendi_ruled_based_bt:float",
          order: "desc",
          isForParent: "true",
          isForVariation: "false",
        });
      }
    } else {
      //else make sure that selected sort is applying
      newSort = filter.sort;
    }
    filter.sort = newSort;
    if (isSortJson) {
      filter.sort = JSON.stringify(filter.sort);
    }
    if (isJson) {
      filter = JSON.stringify(filter);
    }
  };

  const addSizeSorting = (filter, isFilter) => {
    let isJson = false;
    let isSortJson = false;
    if (typeof filter == "string") {
      isJson = true;
      filter = JSON.parse(filter);
    }
    if (typeof filter.sort == "string") {
      isSortJson = true;
      filter.sort = JSON.parse(filter.sort);
    }
    let newSort = [];
    //when sort is relevance than update sort as per requierment
    if (filter.sort[0].field === "relevance") {
      if (!isFilter) {
        newSort.push({
          field: "product_ksa:float",
          order: "desc",
          // order: "asc",
        });
      }
      filter.sort.forEach((x) => {
        if (x.field != "product_ksa:float") {
          newSort.push(x);
        }
      });
    } else {
      //else make sure that selected sort is applying
      newSort = filter.sort;
    }
    if (isFilter) {
      newSort.push({
        field: "product_ksa:float",
        order: "desc",
        // order: "asc",
      });
    }
    filter.sort = newSort;
    if (isSortJson) {
      filter.sort = JSON.stringify(filter.sort);
    }
    if (isJson) {
      filter = JSON.stringify(filter);
    }
  };
  const preloadImg = () => {
    let images = {};
    for (var i = 0; i < arguments.length; i++) {
      images[i] = new Image();
      images[i].src = preload.arguments[i];
    }
  };
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (filter) {
      addSizeSorting(filter, false);
      $(".CollectionMain .navigation").css("display", "none");
      $(".CollectionMain .SectionHeader.SectionHeader--center").css(
        "display",
        "none"
      );
      $(".CollectionInner").css("margin-top", "0px");
      $(".main_container_offers").css("display", "none");
      return filter;
    }
  );

  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  //   function (filter) {
  //     if (
  //       window.wizzyConfig.common.isOnCategoryPage &&
  //       containsCollection(window.wizzyConfig.common.collectionHandle)
  //     ) {
  //       addCollectionSorting(filter.filters);
  //     } else if (
  //       window.wizzyConfig.common.isOnCategoryPage &&
  //       containsCollectionForHero(window.wizzyConfig.common.collectionHandle)
  //     ) {
  //       addCollectionSortingWithHero(filter.filters);
  //     } else if (
  //       window.wizzyConfig.common.isOnCategoryPage &&
  //       containsCollectionForHeroColor(
  //         window.wizzyConfig.common.collectionHandle
  //       )
  //     ) {
  //       addCollectionColorSort(filter.filters);
  //     } else if (
  //       window.wizzyConfig.common.isOnCategoryPage &&
  //       containsCollectionForBestSellingSort(
  //         window.wizzyConfig.common.collectionHandle
  //       )
  //     ) {
  //       addBestSellerAndSizeSorting(filter.filters);
  //     } else if (
  //       window.wizzyConfig.common.isOnCategoryPage &&
  //       containsCollectionForNewestFirst(
  //         window.wizzyConfig.common.collectionHandle
  //       )
  //     ) {
  //       addNewestFirstSorting(filter.filters);
  //     } else {
  //       addSizeSorting(filter.filters, true);
  //     }
  //     // addSizeSorting(filter.filters);
  //     return filter;
  //   },
  //   1
  // );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (filter) {
      if (!filter.sort) {
        filter.sort = [
          {
            field: "relevance",
            order: "asc",
          },
        ];
      }

      addSizeSorting(filter, false);
      return filter;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      // console.log(payload);

      if (window.wizzyConfig.common.isOnCategoryPage == true) {
        // payload.search.configs.general.noOfProducts = 12;
        payload.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-wrapper",
        ];
      } else {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      // wizzyConfig.search.configs.pagination.infiniteScrollOffset.desktop="2"
      if ($("body").hasClass("template-collection")) {
        payload.common.isOnCategoryPage = true;
        // Getting collection handle from the url
        $(document).ready(function () {
          var url = window.location.href;
          var collectionHandle = "";
          var match = url.match(/\/collections\/([^/?]+)/);
          if (match && match[1]) {
            collectionHandle = match[1];
            payload.common.categoryUrlKey = collectionHandle;
          }
        });
      }
      //setting Wedding ritual facet fot perticular collection
      if (
        window.wizzyConfig.common.isOnCategoryPage &&
        window.wizzyConfig.common.collectionHandle !== "wedding-festivities"
      ) {
        payload.search.configs.facets.configs =
          payload.search.configs.facets.configs.filter(
            (item) => item.key !== "product_value_tags_wedding_rituals"
          );
        // console.log(payload.search.configs.facets.configs);
      }
      if (!window.wizzyConfig.common.isOnCategoryPage) {
        // console.log("I am on collection page");
        payload.search.configs.facets.configs =
          payload.search.configs.facets.configs.filter(
            (item) =>
              item.key !== "product_colour_custom" && item.key !== "colors"
          );
      }
      // Setting Identifier for Collection Page
      if (window.wizzyConfig.common.isOnCategoryPage == true) {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-wrapper",
        ];
      } else {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      }
      // Setting Identifier for Autocomplete :-
      payload.common.lazyDOMConfig.searchInputIdentifiers = [];
      payload.common.lazyDOMConfig.searchInputIdentifiers.push({
        dom: ".Search__Input",
        type: "text",
      });
      // Changing wizzy autocomplete div position:-
      // const elementToMove = document.querySelector(".wizzy-body-end-wrapper");
      // const parentElement = elementToMove.parentNode.parentNode;
      // parentElement.parentNode.insertBefore(elementToMove, parentElement);
      payload.filters = { configs: { keepOpenedInMobileAfterApply: true } };

      // Setting scrolling offset
      var recentlyViewedProduductDiv = $(".Section.Section--spacingNormal")[0];
      var seoTextDiv = //$(".Section.Section--spacingNormal")[1] ;
        (seoTextDiv = 0);
      if (window.wizzyConfig.common.isOnCategoryPage) {
        window.wizzyConfig["search"]["configs"]["pagination"][
          "infiniteScrollOffset"
        ] = {
          desktop:
            $("#section-footer").height() +
            $(recentlyViewedProduductDiv).height() +
            0 +
            1200,
          mobile:
            $("#section-footer").height() +
            $(recentlyViewedProduductDiv).height() +
            0 +
            1000,
        };
      } else {
        window.wizzyConfig["search"]["configs"]["pagination"][
          "infiniteScrollOffset"
        ] = {
          desktop: $("#section-footer").height() + 100,
          mobile: $("#section-footer").height() + 100,
        };
      }
      return payload;
    }
  );
  // Logic for variationId

  //////////////////////////////////////////////////code added by paras/////////////////////////////////////

  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  //   function (products) {
  //     products.forEach((product) => {
  //       if (product.images.length === 1) {
  //         /*Changes - 16-01-2025 - starts*/
  //         product.hoverImage = product.mainImage;
  //         /*Changes - 16-01-2025 - ends*/
  //         // console.log(product);
  //       }
  //       const productSizeSwatch = product.swatches?.find(
  //         (item) => item.key === "sizes"
  //       );
  //       // console.log(productSizeSwatch);
  //       if (productSizeSwatch && productSizeSwatch.values.length > 0) {
  //         product.hasFreeSize = productSizeSwatch.values.some(
  //           (item) => item.value === "Freesize"
  //         );
  //       }

  //       product.attributes?.forEach((attribute) => {
  //         if (attribute?.id == "product_tags") {
  //           let values = attribute.values[0].value[0];
  //           const match = values.match(/badge2_([^,]+)/);
  //           if (match) {
  //             product.badge2 = match[1].replace(/_/g, " ");
  //             // console.log(
  //             //   match[1].replace(/_/g, " "),
  //             //   "<<==========================par"
  //             // ); // Replace underscores with spaces if present
  //           }
  //         }
  //       });
  //     });
  //     // console.log(products, "<<<<<<<<<<<<<<<<<<<<<products");
  //     if (
  //       window.wizzyConfig.common.collectionHandle === "eoss-special" ||
  //       window.wizzyConfig.common.collectionHandle === "buy-2-eoss-offer" ||
  //       window.wizzyConfig.common.collectionHandle === "buy-3-eoss-offer"
  //     ) {
  //       products.forEach((product) => {
  //         product.buyTwoAvailable = false;
  //         product.buyThreeAvailable = false;
  //         if (product.attributes) {
  //           product.attributes.forEach((attribute) => {
  //             if (attribute.id === "product_tags") {
  //               if (attribute.values[0].value[0]) {
  //                 if (attribute.values[0].value[0].includes("Buy2")) {
  //                   product.buyTwoAvailable = true;
  //                 }
  //                 if (attribute.values[0].value[0].includes("Buy3")) {
  //                   product.buyThreeAvailable = true;
  //                 }
  //               }
  //             }
  //           });
  //         }
  //       });
  //     }
  //     return products;
  //   }
  // );
  ////////////////////////////////////////////paras code end//////////////////////////////////////////////////
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  //   function (payload) {
  //     payload.map((product, index) => {
  //       let attributes = product.attributes;

  //       const tags = attributes
  //         .find((x) => x.id === "product_tags")
  //         ?.values.flatMap((x) => x.value);
  //       // let limited_sale = tags !== undefined && tags.length > 0 ? tags[0] : "";
  //       // limited_sale = limited_sale
  //       //   .split(",")
  //       //   .find((tag) => tag.includes("badge_"))
  //       //   ?.split("_")[1];
  //       // product.tags = limited_sale ? limited_sale : "";

  //       let limited_sale_1 =
  //         tags !== undefined && tags.length > 0 ? tags[0] : "";
  //       badgeOne = limited_sale_1
  //         .split(",")
  //         .find((tag) => tag.includes("badgeOne_"))
  //         ?.split("_")[1];
  //       product.badgeOne = badgeOne ? badgeOne : "";

  //       let limited_sale_2 =
  //         tags !== undefined && tags.length > 0 ? tags[0] : "";
  //       badgeTwo = limited_sale_2
  //         .split(",")
  //         .find((tag) => tag.includes("badgeTwo_"))
  //         ?.split("_")[1];
  //       product.badgeTwo = badgeTwo ? badgeTwo : "";

  //       let mainImage = product.mainImage;
  //       product.mainImage = product.hoverImage;
  //       product.hoverImage = mainImage;

  //       preloadImg(product.mainImage, product.hoverImage);

  //       product.varientId = product.id;
  //       if (product?.swatches?.length !== 0) {
  //         product.productHasSwatches = true;
  //       }
  //       // removing 00 from the prices
  //       if (product.price) {
  //         product.price = parseInt(product.price.replace(/,/g, ""), 10);
  //       }
  //       if (product.sellingPrice) {
  //         product.sellingPrice = parseInt(
  //           product.sellingPrice.replace(/,/g, ""),
  //           10
  //         );
  //       }
  //     });
  //     $(document).on("click", ".autocomplete-link", function () {
  //       var dataTerm = $(this).attr("data-searchterm");
  //       $(".wizzy-search-input").val(dataTerm);
  //       var form = document.getElementsByClassName("Search__Form")[0];
  //       form.submit();
  //     });
  //     return payload;
  //   }
  // );
  // Replacing default template

  // replaceTemplate("wizzy-autocomplete-topproducts");
  // replaceTemplate("wizzy-search-results-product");

  //submitting a wizzy search form
  var input = document.getElementsByClassName("wizzy-search-input")[0];
  input.addEventListener("keydown", function (e) {
    if (event.key === "Enter" || event.keyCode === 13) {
      var form = document.querySelector(".Search__Form");
      var hiddenInputs = form.querySelectorAll('input[type="hidden"]');
      hiddenInputs.forEach(function (input) {
        input.remove();
      });
    }
  });

  //close btn click on form submit
  var form = document.getElementsByClassName("Search__Form")[0];
  form.addEventListener("submit", function (e) {
    document.getElementsByClassName("Search__Close")[0].click();
  });

  // code for swatches dropdown
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      var dropdowns = document.querySelectorAll(".swatch-dropdown");
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener("change", function () {
          var selectedOption = dropdown.options[dropdown.selectedIndex];
          var selectedSwatchValue = selectedOption.value;
          var currentDropDown = $(this).parent();
          var currentCart = currentDropDown.find("#cartBtnNew");
          currentCart.attr("value", selectedSwatchValue);
          // Buy now
          var currentBuyBtn = currentDropDown.find(".buyBtnNew");
          currentBuyBtn.attr(
            "href",
            "/cart/" + selectedSwatchValue + ":1?checkouts"
          );
        });
      });

      if (wizzyConfig.pageStore.searchSubmitValue) {
        if (wizzyConfig.pageStore.searchSubmitValue.includes("rakhi")) {
          let aspectRatioDivs = document.querySelectorAll(
            ".AspectRatio.AspectRatio--withFallback"
          );
          // console.log(aspectRatioDivs);
          aspectRatioDivs.forEach((div) => {
            div.style.setProperty("--aspect-ratio", "1");
          });
        }
      }

      const validHandles = [
        "rakhi",
        "gold-rakhi",
        "brass-rakhi",
        "kids-rakhi",
        "silver-rakhi",
      ];

      if (validHandles.includes(wizzyConfig.common.collectionHandle)) {
        let aspectRatioDivsNew = document.querySelectorAll(
          ".AspectRatio.AspectRatio--withFallback"
        );
        // console.log(aspectRatioDivsNew);
        aspectRatioDivsNew.forEach((div) => {
          div.style.setProperty("--aspect-ratio", "1");
        });
      }

      return payload;
    }
  );
  // Sizes order in filters
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      payload.response.payload.facets.forEach((facet) => {
        if (facet.key == "sizes") {
          const sizes = facet.data;
          const sizeOrder = {
            Freesize: 1,
            "2XS": 2,
            XS: 3,
            S: 4,
            M: 5,
            L: 6,
            XL: 7,
            "2XL": 8,
            "3XL": 9,
            "4XL": 10,
            "5XL": 11,
            "6XL": 12,
          };
          sizes.sort((a, b) => {
            const orderA = sizeOrder[a.key];
            const orderB = sizeOrder[b.key];
            if (orderA < orderB) {
              return -1;
            } else if (orderA > orderB) {
              return 1;
            } else {
              return 0;
            }
          });
        }
      });
      // Suggestion submit
      return payload;
    }
  );

  ////////////////////////////////////////////////////////

  // const urls = [
  //   "https://www.truebrowns.com/collections/rakhi",
  //   "https://www.truebrowns.com/collections/silver-rakhi",
  //   "https://www.truebrowns.com/collections/gold-rakhi"
  // ];

  // $(document).ready(function () {
  //     if (urls.includes(window.location.href)) {
  //         replaceCollectionTemplate("wizzy-search-results-product");
  //     }
  // })
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};

function wizzycheck_Validvalue(selector) {
  if (
    parseInt(selector.value) !== 0 &&
    selector.classList.contains("invalidSelection")
  ) {
    selector.classList.remove("invalidSelection");
  }
}
